import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import Axios from 'axios';
import Config from '../../Constants/index'
import Alert from '../../Component/Alert'
import CalibrationTypeLkp from '../../Component/Calibration/CalibrationTypeLkp';
import UserDefaultCustomer from '../../Component/Calibration/UserDefaultCustomer';
import UnitOfMeasurmentLkp from '../../Component/Calibration/UnitOfMeasurmentLkp';
import t from '../../Lang/Index'
import ReportTemplateLkp from '../../Component/Calibration/ReportTemplateLkp';
import CalibrationProcedureLkp from '../../Component/Calibration/CalibrationProcedureLkp';
import NavBar from '../../Navigation/NavBar';
import Footer from '../../Navigation/Footer';
import { getAuth, onAuthStateChanged, getIdToken } from "firebase/auth";
import { useAuthState } from 'react-firebase-hooks/auth'

const CertOfCalCopy = (props) => {

    const PAGE_TITLE = "Copy Cert Of Cal";
    
    const [sourceCertId, setSourceCertId] = React.useState('');
    const [targetCertId, setTargetCertId] = React.useState('');
      
    const [isRedirectToCertOfCal, setIsRedirectToCertOfCal] = React.useState(false)
    const [messages, setMessages] = React.useState([]);
    const [copyEnabled, setCopyEnabled] = React.useState(true);
    
    const auth = getAuth();
    const [user, loading, error] = useAuthState(auth);

    const onSourceCertIdChange = (e) => setSourceCertId(e.target.value);
    const onTargetCertIdChange = (e) => setTargetCertId(e.target.value);

    const cancel = () => {
        setIsRedirectToCertOfCal(true);
    }

    const copy = () => {
        let messagesList = [];
        let self = this;

        getIdToken(user).then((idToken) => {

            Axios.post(Config.API_URL + "CertificateOfCalibration/Copy",
                {
                    SourceCertId: sourceCertId || 0,
                    TargetCertId: targetCertId || 0
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + idToken
                    }
                })
                .then(response => {
                    //TODO Show message
                   setIsRedirectToCertOfCal(true);
                })
                .catch(error => {
                    debugger;
                    if (error.response && error.response.status == 400) {
                        for (var key in error.response.data) 
                            if (key.startsWith("message")) 
                                messagesList.push(error.response.data[key]);                                                   
                    }
                    else {
                        messagesList.push("Failed to connect to server")
                    }
                    setMessages(messagesList);
                });
        });
    } 


    if (isRedirectToCertOfCal) {
        return <Redirect to={"/CertificateOfCalibration/"}></Redirect>
    }

    return (

        <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
            <NavBar />
            <div className="container-fluid py-4">
                <div className="col-lg-9 col-12 mx-auto position-relative">
                    <div className="card">
                        <div className="card-header p-3 pt-2">
                            <div className="icon icon-lg icon-shape bg-gradient-dark shadow text-center border-radius-xl mt-n4 me-3 float-start">
                                <i class="fa fa fa-copy fa-fw" aria-hidden="true"></i>
                            </div>
                            <h6 className="mb-0">{PAGE_TITLE}</h6>
                        </div>
                        <div className="card-body pt-2">
                            <div className="col-12">
                                <div className="input-group input-group-static  my-3">
                                    <label>
                                        Source CertId
                                    </label>
                                    <input type="text" class="form-control" name="description" onChange={onSourceCertIdChange} value={sourceCertId} />
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="input-group input-group-static  my-3">
                                    <label>
                                        Target CertId
                                    </label>
                                    <input type="text" class="form-control" name="description" onChange={onTargetCertIdChange} value={targetCertId} />
                                </div>
                            </div>

                            {messages.length > 0 &&
                                <Alert messages={messages}></Alert>}
                            <div className="d-flex justify-content-end mt-4">
                                <button type="button" class="btn btn-light m-0" onClick={cancel}>
                                    Cancel
                                </button>
                                <button type="button" class="btn bg-gradient-dark m-0 ms-2" onClick={copy} disabled={!copyEnabled} >
                                    Copy
                                </button>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </main >

    )

}

export default CertOfCalCopy;